<div class="dialog-header">
  {{ "prolindung.customerForm.submitted" | translate }}
</div>

<mat-divider></mat-divider>

<div class="dialog-content">
  <div>{{ "prolindung.customerForm.submittedDesc" | translate }}</div>
  <div>{{ "prolindung.customerForm.submittedDesc2" | translate }}</div>
</div>

<div class="dialog-footer">
  <button mat-flat-button type="button" class="btn" (click)="goTo()">
    {{ "prolindung.customerForm.view" | translate }}
  </button>
</div>
